import { renderBookmarkStart } from './bookmark';
import type { RenderBreakOptions } from './break';
import { renderBreak } from './break';
import { renderCannedField } from './canned-field';
import { renderCheckbox } from './checkbox';
import { renderDrawing } from './drawing';
import { renderInlineInstructionField } from './inline-instruction-field';
import { renderInputField } from './input-field';
import { renderInvisible } from './invisible';
import { renderLink } from './link';
import { renderTab } from './tab';
import type { RenderTextOptions } from './text';
import { renderText } from './text';
import { isRenderModelInlineInstructionFieldEntry } from '../../slate-api';
import type { RenderModelInline, RenderModelText } from '../../slate-api';
import type { RenderNodeFnsOf } from '../engine/render-context';

export type RenderInlineOptions = RenderTextOptions & RenderBreakOptions;

export const renderInlineFns: RenderNodeFnsOf<
  RenderModelInline | RenderModelText,
  RenderInlineOptions
> = {
  CANNED: renderCannedField,
  INPUT: renderInputField,
  bookmarkEnd: renderInvisible,
  bookmarkStart: renderBookmarkStart,
  break: renderBreak,
  checkbox: renderCheckbox,
  drawing: renderDrawing,
  'dynamic-inline': renderInvisible,
  instructionField: (renderContext, rMNodeEntry, options) => {
    if (!isRenderModelInlineInstructionFieldEntry(rMNodeEntry)) return;
    renderInlineInstructionField(renderContext, rMNodeEntry, options);
  },
  link: renderLink,
  suggestionMarkerEnd: renderInvisible,
  suggestionMarkerStart: renderInvisible,
  tab: renderTab,
  text: renderText,
};
